var forceReflow = function(node) {
  return node.scrollTop;
};
export {
  forceReflow
};
//# sourceMappingURL=reflow.js.map
